import React from 'react'
import { TextareaAutosize } from '@mui/material'

import NoteV2 from './NoteV2'
import ShowMoreLess from '../../../atoms/ShowMoreLess'
import useNotes from '../../../../hooks/useNotes'
import useStyles from './styles'

const NotesV2 = ({ user }) => {
  const { notes = {}, handleChangeNote, addNote, deleteNote } = useNotes(
    user?.id
  )
  const [expanded, setExpanded] = React.useState(false)
  const [note, setNote] = React.useState('')
  const [startingNote, setStartingNote] = React.useState('')
  const [noteID, setNoteID] = React.useState('')
  const [findID, setFindID] = React.useState(true)

  const textRef = React.useRef()

  const classes = useStyles()

  React.useEffect(() => {
    setExpanded(false)
  }, [user])

  // Sets noteID to last note on first render
  React.useEffect(() => {
    if (!findID) {
      return
    }

    const ids = Object.keys(notes)
    const last = ids[ids.length - 1]
    setNoteID(last)

    if (last !== noteID) {
      setFindID(false)
    }
  }, [findID, noteID, notes])

  const saveNote = React.useCallback(() => {
    if (note.trim().length && note !== startingNote) {
      handleChangeNote(noteID)(note, true)
    }
    setNote('')
    setStartingNote('')
    addNote()
    setFindID(true)
  }, [addNote, handleChangeNote, note, noteID, startingNote])

  const handleNoteClicked = key => () => {
    setNoteID(key)
    const note = notes[key].content
    setNote(note)
    setStartingNote(note)
    textRef.current.focus()
  }

  const handleKeyDown = React.useCallback(
    e => {
      if (e.key === 'Enter' && !e.shiftKey && note.trim().length) {
        saveNote()
        e.preventDefault()
        return
      }
    },
    [saveNote, note]
  )

  const notesArr = React.useMemo(
    () =>
      Object.entries(notes)
        .filter(([key, { content, ...note }], i) => content)
        .sort((a, b) => new Date(a[1].stamp) - new Date(b[1].stamp)),
    [notes]
  )

  const notesToRender = expanded ? notesArr : [...notesArr].slice(0, 3)
  return (
    <React.Fragment>
      <div className={classes.root}>
        <div className={classes.textField}>
          <TextareaAutosize
            className={classes.input}
            minRows={1}
            maxRows={6}
            ref={textRef}
            placeholder='Write new notes ...'
            value={note}
            onChange={e => setNote(e.target.value)}
            onKeyDown={handleKeyDown}
            onBlur={saveNote}
          />
        </div>
        {notesToRender.map(([key, { content, ...note }], i) =>
          key === noteID || !content ? null : (
            <NoteV2
              key={key}
              onDelete={deleteNote(key)}
              onClick={handleNoteClicked(key)}
              note={note}
            >
              {content}
            </NoteV2>
          )
        )}
      </div>
      {notesArr.length > 3 && (
        <ShowMoreLess expanded={expanded} setExpanded={setExpanded} />
      )}
    </React.Fragment>
  )
}

export default NotesV2
